<template>
  <div class="project">
    <div class="right-container">
      <div>
        <!-- <transition name="fadeOne">
          <div v-show="show" class="container-2"> -->
        <p class="One">Safe Space</p>
        <p class="description">
          This was a group project I managed. Our task was to make a space
          themed website for children aged 8-12. My task was to code after
          the wireframe.
        </p>
        <!-- </div>
        </transition> -->
        <transition name="fadeTwo">
          <div class="container-2">
            <!-- <a href="https://bagel-79264.web.app/" class="Two"
              >click here to visit</a> -->
          </div>
        </transition>
      </div>
    </div>
    <div class="p-image"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.container-2 {
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
}
.project {
  width: auto;
  height: auto;
  background: #4dba87;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 15px;
}
button {
  color: #435466;
  font-size: 15px;
  font-weight: 600;
  background-color: #fff;
  margin: auto;
  width: 100px;
  height: 50px;
  border: #3b3561;
}
.description {
  font-size: 1.5em;
  font-family: "Roboto", sans-serif;
}
.right-container {
  display: grid;
  grid-template-rows: 1fr 0.1fr;
}
.p-image {
  background: url("../assets/safe-space.png");
  height: 35vh;
  width: 62vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
p {
  text-align: start;
  font-size: 50px;
  font-family: "Stalinist One", cursive;
  overflow: hidden;
  color: #000;
  margin: 1px;
}

.Two {
  font-size: 18px;
}

.fadeOne-enter-active,
.fadeOne-leave-active {
  transition: all 0.5s ease-out;
}
.fadeOne-enter,
.fadeOne-leave-to {
  clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%);
  transform: translate(0%, 100%);
}

.fadeTwo-enter-active,
.fadeTwo-leave-active {
  transition: all 0.5s ease-out;
}
.fadeTwo-enter,
.fadeTwo-leave-to {
  clip-path: polygon(0% 100%, 100% 100%, 0% 100%, 0% 100%);
  transform: translate(0%, -100%);
}
@media screen and (max-width: 900px) {
  .project {
    width: 100%;
    grid-template-columns: 1fr;
    place-items: center;
  }
  .p-image {
    width: 44.4vh;
    height: 25vh;
  }
}
</style>
